import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { graphql } from 'gatsby';

import { Alert } from '@lanl-web/lanl-components';

import { publishedFilter } from '../../utils';

import './AlertList.scss';

export const AlertList = ({ className, alerts }) => {
  const publishedAlerts = publishedFilter(alerts);

  const classes = classNames('alert-list', className);

  return (
    publishedAlerts.length > 0 && (
      <div className={classes}>
        {publishedAlerts.map(({ alert }, index) => (
          <Alert key={`alert-${index}`}>
            <div
              className='alert-text'
              dangerouslySetInnerHTML={{ __html: alert }}
            />
          </Alert>
        ))}
      </div>
    )
  );
};

AlertList.defaultProps = {
  alerts: [],
};

AlertList.propTypes = {
  alerts: PropTypes.array.isRequired,
};

export default AlertList;

export const alertList = graphql`
  fragment alertList on DirectusData {
    rl_alert {
      alert
      status
    }
  }
`;
